import { ConfigurarPastaServiceService } from "app/configurar-pasta-service.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatPaginator,
  MatSnackBar,
  MatTableDataSource,
  MatSort,
} from "@angular/material";
import {
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { ActivatedRoute } from "@angular/router";
import { CriarAspectosComponent } from "../../vincular-tipo-cliente/criar-aspectos/criar-aspectos.component";
import { MatDialog } from "@angular/material/dialog";
import { EditAspectDialogComponent } from "../dialog/edit-aspect-dialog/edit-aspect-dialog.component";
import { ClienteService } from "app/service/cliente/cliente.service";
import { PermissoesService } from "app/service/usuario/permissoes.service";
import { DialogConfirmComponent } from "../dialog/dialog-confirm/dialog-confirm.component";

@Component({
  selector: "app-manter-aspect",
  templateUrl: "./manter-aspect.component.html",
  styleUrls: ["./manter-aspect.component.scss"],
})
export class ManterAspectComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns = ["title", "name", "description", "ativo", "actions"];
  dataSource = new MatTableDataSource<any[]>([]);
  clienteId: number;
  public dataAspects = [""];
  public modelsById: number;
  public nameEmpresa: String;
  public authorityArray: String[];
  public loading = true;
  horizontalPosition: MatSnackBarHorizontalPosition = "right";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  public isMostrarTiposDoc = true;
  // PERMISSÕES
  public authorityUser = [];
  public superUser = false;
  public addAspectos = false;
  public editarAspectos = false;
  public listarAspectos = false;
  public excluirAspectos = false;

  constructor(
    public service: ConfigurarPastaServiceService,
    private activeRoute: ActivatedRoute,
    public dialog: MatDialog,
    private clienteService: ClienteService,
    private permissoesService: PermissoesService,
    private _snackBar: MatSnackBar
  ) {
    this.activeRoute.params.subscribe(
      (params) => (this.clienteId = params["id"])
    );
    console.log(this.clienteId);
  }

  ngOnInit() {
    if (this.clienteId != null) {
      this.listarNomeEmpresa();
      this.serchModelsByIdClient();
      this.getPermissionCliente(this.clienteId);
      this.service.isChangedNode.subscribe(() => {
        this.serchModelsByIdClient();
      });
    } else {
      this.isMostrarTiposDoc = false;
      this.getAllAspectsNotLinkedToClient();
      this.getGlobalPermissionUser();
      this.isMostrarTiposDoc = false;
      this.service.isChangedNode.subscribe(() => {
        this.getAllAspectsNotLinkedToClient();
      });
    }
  }

  applyFilterTypes(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSource.filter = filter;
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  serchModelsByIdClient() {
    console.log(this.clienteId);
    if (this.clienteId == undefined) {
      this.isMostrarTiposDoc = false;
      this.getAllAspectsNotLinkedToClient();
      if (this.dataSource.data.length == 0) {
        this.openSnackBar("Você não tem aspectos cadastrados !", true);
      }
      //listar todos os aspectos, sem vinculação
    } else {
      this.service.getModelByIdClient(this.clienteId).subscribe(
        (data) => {
          this.loading = false;
          console.log(data);
          this.dataSource.data = data;
          this.modelsById = data;
          if (this.dataSource.data.length == 0) {
            this.openSnackBar("Você não tem aspectos cadastrados !", true);
          }
          // console.log(this.modelsById);
        },
        (error) => {
          this.loading = false;
          console.error(error);
        }
      );
    }
  }
  getAllAspectsNotLinkedToClient() {
    this.service.getAllAspectsNotLinkedToClient().subscribe((data) => {
      this.dataSource.data = data;
      this.dataSource.paginator = this.paginator;
      console.log(data);
    });
  }
  openCriarAspecto() {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + "px";
    } else {
      largura = innerWidth / 2 + "px";
    }

    const dialogRef = this.dialog.open(CriarAspectosComponent, {
      data: { clientId: this.clienteId },
      // width: largura,
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          this.serchModelsByIdClient();
          this.loading = false;
        }
      },
      (error) => {
        console.error(error);
        this.loading = false;
      }
    );
  }

  // ListarAspectByModelId() {
  //   this.service.getAspectByModelId(407).subscribe((data) => {
  //     this.dataSource.data = data;
  //   });
  // }

  openAspectEditDialog(asp) {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + "px";
    } else {
      largura = innerWidth / 2 + "px";
    }

    const dialogRef = this.dialog.open(EditAspectDialogComponent, {
      data: { clientId: this.clienteId, asp },
      width: largura,
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          this.serchModelsByIdClient();
        }
      },
      (err) => {
        this.handleError(
          err,
          "Ocorreu um erro, tente novamente em alguns instantes"
        );
      }
    );
  }

  handleError(error, msg) {
    this.loading = false;
    console.error(error);
    this.openSnackBar(
      `Ocorreu um erro ${msg}, tente novamente em alguns instantes`,
      true
    );
  }

  listarNomeEmpresa() {
    if (this.clienteId != null) {
      this.clienteService.nomeCliente(this.clienteId).subscribe(
        (data) => {
          this.nameEmpresa = data;
          console.log(this.nameEmpresa);
        },
        (err) => {
          console.error(err);
          this.nameEmpresa = err.error.text;
        }
      );
    }
  }

  getAuthority() {
    this.authorityArray.includes("SUPER_USER") ? (this.superUser = true) : null;
    this.authorityArray.includes("LISTAR_ASPECT")
      ? (this.listarAspectos = true)
      : null;
    this.authorityArray.includes("EDIT_ASPECT")
      ? (this.editarAspectos = true)
      : null;
    this.authorityArray.includes("ADD_ASPECT")
      ? (this.addAspectos = true)
      : null;
    this.authorityArray.includes("EXCLUIR_ASPECT")
      ? (this.excluirAspectos = true)
      : null;
  }

  getPermissionCliente(idCliente) {
    if (this.clienteId != null) {
      this.authorityArray = [];
      this.clienteId;
      console.log(idCliente);
      this.permissoesService.getPermissionEmpresa(this.clienteId).subscribe(
        (data: any[]) => {
          //verifica se nenhuma permissão foi encontrada
          this.authorityArray = data.map((el) => el.authority);
          const itensPermissoes = [
            "ADD_ASPECT",
            "EDIT_ASPECT",
            "SUPER_USER",
            "LISTAR_ASPECT",
            "EXCLUIR_ASPECT",
          ];
          if (
            !itensPermissoes.some(
              (e) => this.authorityArray.includes(e),
              console.log(this.authorityArray)
            )
          ) {
            return this.openSnackBar(
              "Você não tem as permissões necessárias",
              true
            );
          }
          this.getAuthority();
        },
        (err) => {
          console.error(err);
          this.openSnackBar(
            "Ocorreu um erro, tente novamente mais tarde",
            true
          );
        }
      );
    }
  }

  openDeletAspect(aspect) {
    console.log(aspect);
    this.service.getModelByIdClient(aspect).subscribe((data) => {
      console.log(data);
    });
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Deseja realmente apagar este aspecto ?",
        from: "manter-aspect.component.ts",
        clientId: this.clienteId,
        aspect,
      },
      // clientId: this.clienteId
    });
    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.deletAspect(aspect);
      }
    });
  }

  deletAspect(aspect) {
    this.service.excluirAspect(aspect).subscribe(
      (data) => {
        this.serchModelsByIdClient();
        this.openSnackBar("Aspecto excluido com sucesso !", false);
      },
      (error) => {
        if (error.error.message.includes("could not execute statement;")) {
          this.openSnackBarError(
            "Este aspecto já está vinculado a um tipo documental !"
          );
          console.error(error);
        } else {
          this.openSnackBarError(
            "Erro ao excluir aspecto, tente novamente em instantes !"
          );
          console.error(error);
        }
      }
    );
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, "", {
      horizontalPosition: "right",
      verticalPosition: "top",
      duration: 3000,
      panelClass: isErr ? ["info-snackbar"] : ["success-snackbar"],
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ["error-snackbar"],
    });
  }

  getGlobalPermissionUser() {
    this.permissoesService.getPermissionsInUserLogged().subscribe(
      (data: any[]) => {
        this.authorityUser = data.map((el) => el.name);
        this.getAuthorityUser();
        this.loading = false;
      },
      (err) => {
        this.loading = false;
      }
    );
  }
  getAuthorityUser() {
    if (
      this.authorityUser.includes("SUPER_USER") ||
      this.authorityUser.includes("LISTAR_ASPECT")
    ) {
      this.superUser = true;
      this.listarAspectos = true;
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/manter-aspect/manter-aspect.component.ts